import firebase from 'firebase';
import { sharetag, getsurvey, updatealerts, gettags } from '@/functions.js';

function zero2digit(v) {
    var s = "" + v;
    if (s.length < 2)
        s = "0" + s;
    return s;
};

export default{

    mutations: {
        setSurveys(state, payload) {
            this.state.surveys = payload;
            this.state.updatecount++;
        },
        addSurvey(state, payload) {
            //alert('addSurvey');
            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            if ((payload.Name == null) || (payload.Name.length < 1)) {
                //payoad.Name = new DateTime(ticks).ToString("dd-MMM-yy HH:mm");
                var ticksToMicrotime = payload.StartTime / 10000;
                var epochMicrotimeDiff = Math.abs(new Date(0, 0, 1).setFullYear(1));
                var tickDate = new Date(ticksToMicrotime - epochMicrotimeDiff);

                var yy = tickDate.getYear()-100;
                var MM = months[tickDate.getMonth()];
                var dd = tickDate.getDate();
                var HH = tickDate.getHours();
                var mm = tickDate.getMinutes();

                payload.Name = "" + zero2digit(dd) + "-" + MM + "-" + zero2digit(yy) + " " + zero2digit(HH) + ":" + zero2digit(mm);
            }
            this.state.surveys.push(payload);
            this.state.updatecount++;
        },
        cutSurvey(state,payload){
            const deleted = this.state.surveys.find(survey => survey.ID === payload);
            const index = this.state.surveys.indexOf(deleted);
            this.state.surveys.splice(index, 1);
            this.state.updatecount++;
        },
        changedSurvey(state,payload){
            //alert('check changedSurvey');
            var changed = this.state.surveys.find(survey => survey.ID === payload.ID);
            var isselected = changed.IsSelected;
            changed.val = payload.val;
            changed.IsSelected = isselected;      
            this.state.updatecount++;
        },
        addMedia(state, payload) {
            var survey = this.state.exploresurvey;
            if (survey.media == null) {
                survey.media = {};
            }
            if (survey.media[payload.ID] == null) {
                survey.media[payload.ID] = { tags: 0 };
            }
            survey.media[payload.ID] = payload;
            survey.media[payload.ID].tags = gettags(payload.ID,survey.ID);
            this.state.mediacount++;
        },
        cutMedia(state, payload) {
            alert("cutMedia");
        },
        changedMedia(state, payload) {
            //alert("changedMedia");
            var survey = this.state.exploresurvey;
            survey.media[payload.ID].DownloadURL = payload.DownloadURL;
        },
        addSurveyTag(state, payload) {
            //alert("addSurveyTag");
            var survey = this.state.exploresurvey;
            if (survey.tags == null) {
                survey.tags = {};
            }
            survey.tags[payload.ID] = payload;

            //alert("addSurveyTag");
            var mediaid = payload.MediaID;
            if (survey.media[mediaid] != null) {
                if (survey.media[mediaid].tags == null) {
                    survey.media[mediaid].tags = {};
                }
                survey.media[mediaid].tags[payload.ID] = payload;
            }

            this.state.surveymodified++;
            updatealerts();
        },
        cutSurveyTag(state, payload) {
            //alert("cutSurveyTag");
            this.state.surveymodified++;
            updatealerts();
        },
        changedSurveyTag(state, payload) {
            //alert("changedSurveyTag");
            this.state.surveymodified++;
            updatealerts();
        },
        addTag(state, payload) {
            //alert("addTag");
            this.state.mytags[payload.ID] = payload;
            this.state.surveymodified++;
            updatealerts();
        },
        cutTag(state, payload) {
            //alert("cutTag");
            this.state.surveymodified++;
            updatealerts();
        },
        changedTag(state, payload) {
            //alert("changedTag");
            this.state.surveymodified++;
            updatealerts();
        }

    },
    actions: {
        cutSurvey(state, survey) {
            alert("cutSurvey in surveys.js " + survey.ID);
            var storage = firebase.storage();
            var storageRef = storage.ref();
            var mediaRef = storageRef.child(state.rootState.user.uid + "/" + survey.ID);
            mediaRef.listAll().then(function (res) {
                res.items.forEach(function (itemRef) {
                    itemRef.delete().then(function () {
                        alert("cutSurvey images deleted");
                    }).catch(function (error) {
                        alert("cutSurvey error A ");
                    });
                });
            }).catch(function (error) {
                alert("cutSurvey error B ");
            });
            firebase.database().ref('databases/' + state.rootState.databaseid + '/users/' + state.rootState.user.uid + '/mydata/mysurveys/' + survey.ID).remove();
            firebase.database().ref('databases/' + state.rootState.databaseid + '/users/' + state.rootState.user.uid + '/survey-data/' + survey.ID).remove();
            mediaRef.delete().then(function () {
                alert("cutSurvey folder deleted");
            }).catch(function (error) {
                alert("cutSurvey error C ");
            });
            var g = 0;
        },
        addTag(state, tag) {
            alert("addTag in surveys.js");
        },
        cutTag(state, tag) {
            alert("cutTag in surveys.js");
        },
        changedTag(state, tag) {
            alert("changedTag in surveys.js");
        }
    }
}